/* eslint-disable @typescript-eslint/no-redeclare */
export const APP_TITLE = 'Buzzjar'
// 4MB
export const FILE_SIZE = 4e6
export const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/gif', 'image/png']

export enum buzzlRoles {
  admin = 'ADMIN',
  operator = 'OPERATOR',
}

export enum customerUserRoles {
  admin = 'ADMIN',
  operator = 'OPERATOR',
  manager = 'MANAGER',
  superAdmin = 'SUPER_ADMIN',
}

export enum ExperienceEvaluation {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE',
}

export enum PlaceClaimStatus {
  CLAIMED = 'CLAIMED',
  PENDING = 'PENDING',
  UNCLAIMED = 'UNCLAIMED',
}

export const placePerPage = 15
export const experiencesPerPage = 15
export const offersPerPage = 15
export const customersPerPage = 15

export enum OfferType {
  reward = 'REWARD',
  offer = 'OFFER',
}

export const OfferRedemptionType = Object.freeze({
  InPerson: 'IN_PERSON',
  Online: 'ONLINE',
} as const)

export type OfferRedemptionType = typeof OfferRedemptionType[keyof typeof OfferRedemptionType]
